import { SURVEY_TEXT_LIMITS } from './surveys';
import { SURVEY_LANGUAGE } from './language';

export const PLUSPOINT_EMAIL = 'PLUSPOINT_EMAIL';

export const MAX_WELCOME_BUTTONS = 6;

export const LOCATIONS_MODE = {
    ALL: 'all',
    SELECTED: 'selected',
};

export const LIVE_CHAT_TEXT_LIMITS = {
    welcome: SURVEY_TEXT_LIMITS.message,
    offline: 1000,
    button: 40,
};

const DEFAULT_WELCOME_MESSAGES = {
    [SURVEY_LANGUAGE.GB]: 'Hi! How can we help you today?',
    [SURVEY_LANGUAGE.ES]: '¡Hola! ¿En qué podemos ayudarle hoy?',
    [SURVEY_LANGUAGE.PT]: 'Olá! Como podemos ajudar você hoje?',
    [SURVEY_LANGUAGE.BR]: 'Olá! Como podemos ajudar você hoje?',
    [SURVEY_LANGUAGE.FR]: 'Bonjour ! Comment pouvons-nous vous aider aujourd’hui ?',
    [SURVEY_LANGUAGE.DE]: 'Hallo! Wie können wir Ihnen heute helfen?',
    [SURVEY_LANGUAGE.PL]: 'Cześć! Jak możemy dziś pomóc?',
    [SURVEY_LANGUAGE.RU]: 'Здравствуйте! Чем мы можем вам помочь сегодня?',
    [SURVEY_LANGUAGE.UA]: 'Вітаємо! Чим можемо допомогти вам сьогодні?',
};

export const getDefaultWelcomeMessage = language =>
    DEFAULT_WELCOME_MESSAGES[language] || DEFAULT_WELCOME_MESSAGES[SURVEY_LANGUAGE.GB];

export const WELCOME_MESSAGE_FIELD = {
    name: 'welcomeMessage',
    label: 'SettingsChannels.welcomeTagline',
    maxLength: LIVE_CHAT_TEXT_LIMITS.welcome,
    multiline: true,
};

export const OFFLINE_MESSAGE_FIELDS = [
    {
        name: 'offlineMessage',
        label: 'SettingsChannels.offlineMessage',
        maxLength: LIVE_CHAT_TEXT_LIMITS.offline,
        multiline: true,
    },
];

export const buttonKey = index => `button${index + 1}`;

export const BUTTON_KEYS = Array.from({ length: MAX_WELCOME_BUTTONS }, (_, index) => buttonKey(index));

export const TEXT_KEYS = ['welcomeMessage', 'offlineMessage', ...BUTTON_KEYS];

export const fillTextRow = row => TEXT_KEYS.reduce((filled, key) => ({ ...filled, [key]: row[key] ?? '' }), { ...row });

export const hasEveryTextKey = row => TEXT_KEYS.every(key => row[key] !== undefined);

export const welcomeButtonFields = count =>
    BUTTON_KEYS.slice(0, count).map((name, index) => ({
        name,
        label: 'SettingsChannels.welcomeButton',
        labelOptions: { number: index + 1 },
        maxLength: LIVE_CHAT_TEXT_LIMITS.button,
    }));

export const getChatLink = publicId =>
    `${(import.meta.env.REACT_APP_SURVEY_DOMAIN || '').replace(/\/+$/, '')}/c/channel/${publicId}`;

export const MAX_ALLOWED_SITES = 50;

const HOSTNAME_PATTERN = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/;
const HOSTNAME_MAX_LENGTH = 253;

export const normalizeAllowedSite = value =>
    String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/^.*?:\/\//, '')
        .replace(/[/?#].*$/, '')
        .replace(/:.*$/, '')
        .replace(/^\*\./, '');

export const isValidHostname = value => value.length <= HOSTNAME_MAX_LENGTH && HOSTNAME_PATTERN.test(value);

export const normalizeAllowedSites = sites => [...new Set((sites || []).map(normalizeAllowedSite).filter(Boolean))];
